import { useState } from 'react';
import { useAuth } from '@/context/AuthContext';
import { summarizeEvent } from '@/lib/eventSummary';
import { ChevronDown, Code2, ArrowRightCircle } from 'lucide-react';
import { cn } from '@/lib/utils';

export function EventSummary({ event, compact = false, showCertainty = true, className = '' }) {
  const { isSuperAdmin } = useAuth();
  const [open, setOpen] = useState(false);
  const s = summarizeEvent(event);
  const id = event?.id || 'x';

  return (
    <div className={cn('font-ibm', className)} data-testid={`event-summary-${id}`}>
      <p className={cn('text-slate-800 dark:text-slate-200', compact ? 'text-xs line-clamp-2' : 'text-sm font-medium')}>
        {s.headline}.{compact && s.reason ? ` ${s.reason}` : ''}
      </p>
      {!compact && s.reason && <p className="text-sm text-slate-600 dark:text-slate-400">{s.reason}</p>}
      {!compact && (s.substance || (showCertainty && s.certainty)) && (
        <p className="text-xs text-slate-500 mt-1 flex flex-wrap gap-x-3">
          {s.substance && <span>{s.substance}</span>}
          {showCertainty && s.certainty && <span>Säkerhet: <b className="text-slate-700 dark:text-slate-300">{s.certainty}</b></span>}
        </p>
      )}
      {!compact && s.action && (
        <p className="mt-1.5 text-sm font-semibold text-navy dark:text-white flex items-start gap-1.5" data-testid={`event-action-${id}`}>
          <ArrowRightCircle className="h-4 w-4 mt-0.5 shrink-0 text-red-500" />
          <span>{s.action}</span>
        </p>
      )}
      {!compact && isSuperAdmin() && event?.explanation && (
        <div className="mt-1.5">
          <button type="button" onClick={() => setOpen(o => !o)} className="text-[11px] text-slate-400 hover:text-navy flex items-center gap-1" data-testid={`event-tech-toggle-${id}`}>
            <Code2 className="h-3 w-3" /> {open ? 'Dölj' : 'Visa'} tekniska detaljer
            <ChevronDown className={cn('h-3 w-3 transition-transform', open && 'rotate-180')} />
          </button>
          {open && (
            <p className="mt-1 text-[11px] font-mono text-slate-500 break-words bg-slate-100 dark:bg-slate-800 rounded p-2" data-testid={`event-tech-details-${id}`}>
              {event.explanation}
            </p>
          )}
        </div>
      )}
    </div>
  );
}
